import MenuBookIcon from "@mui/icons-material/MenuBook";
import { Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useColors from "../api/hooks/useColors";

const DocNavigationButton = ({ sx = {}, ...props }) => {
  const navigate = useNavigate();
  const handleClick = () => navigate("/documentation");
  const colors = useColors();
  return (
    <Button
      onClick={handleClick}
      size="medium"
      startIcon={<MenuBookIcon />}
      sx={{
        textTransform: "none",
        border: `1px solid ${colors.text_primary}`,
        borderRadius: "8px",
        ...sx,
      }}
      {...props}
    >
      <Typography variant="body2">View Component Documentation</Typography>
    </Button>
  );
};

export default DocNavigationButton;
